import { render, staticRenderFns } from "./VerticalNavMenuAdmin.vue?vue&type=template&id=3355ef61"
import script from "./VerticalNavMenuAdmin.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuAdmin.vue?vue&type=style&index=0&id=3355ef61&prod&lang=scss"
import style1 from "./VerticalNavMenuAdmin.vue?vue&type=style&index=1&id=3355ef61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports